import { createSelector } from 'reselect'

const select2FA = state => state.twoFA

export const selectAuthenticationSetup = createSelector([select2FA], twoFA => twoFA.authenticationSetup)

export const selectSuccessMsg = createSelector([select2FA], twoFA => twoFA.success)

export const selectLedgerLoading = createSelector([select2FA], twoFA => twoFA.loading)

export const select2FAtype = createSelector([select2FA], twoFA => twoFA.twoFaType)

export const selectAuthenticationTypes = createSelector([select2FA], twoFA => twoFA.authenticationTypes)
